/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiWebhook } from './ApiWebhook';
import {
    ApiWebhookFromJSON,
    ApiWebhookFromJSONTyped,
    ApiWebhookToJSON,
    ApiWebhookToJSONTyped,
} from './ApiWebhook';

/**
 * 
 * @export
 * @interface ApiWebhookPage
 */
export interface ApiWebhookPage {
    /**
     * 
     * @type {number}
     * @memberof ApiWebhookPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof ApiWebhookPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof ApiWebhookPage
     */
    total: number;
    /**
     * 
     * @type {Array<ApiWebhook>}
     * @memberof ApiWebhookPage
     */
    content: Array<ApiWebhook>;
}

/**
 * Check if a given object implements the ApiWebhookPage interface.
 */
export function instanceOfApiWebhookPage(value: object): value is ApiWebhookPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ApiWebhookPageFromJSON(json: any): ApiWebhookPage {
    return ApiWebhookPageFromJSONTyped(json, false);
}

export function ApiWebhookPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWebhookPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(ApiWebhookFromJSON)),
    };
}

export function ApiWebhookPageToJSON(json: any): ApiWebhookPage {
    return ApiWebhookPageToJSONTyped(json, false);
}

export function ApiWebhookPageToJSONTyped(value?: ApiWebhookPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(ApiWebhookToJSON)),
    };
}

